import React, { useContext } from 'react';
import { BudgetProposalByResourcesOptions } from './CanResourceEditCellRenderer/types';
import { VentilationOptions } from './ProjectionVentilationCellRenderer/types';

type ModalOptionsContextT = {
    ventilationOptions?: VentilationOptions;
    resourceOptions?: BudgetProposalByResourcesOptions;
};
const ModalOptionsContext = React.createContext<ModalOptionsContextT>({
    ventilationOptions: undefined,
    resourceOptions: undefined,
});

export const useModalOptionsContext = () => useContext(ModalOptionsContext);

export default ModalOptionsContext;
